import React from 'react';
import { X, Sparkles } from 'lucide-react';
import CustomLoader from '../../../../../../shared/components/ui/CustomLoader';
import './AIImprovementModal.css';

/**
 * Modal component for AI-driven content refinement
 */
const AIImprovementModal = ({
    isOpen,
    onClose,
    aiPrompt,
    setAiPrompt,
    onRefine,
    isRefining
}) => {
    if (!isOpen) return null;

    return (
        <div className="ai-modal-overlay">
            <div className="ai-modal-content">
                <div className="ai-modal-header">
                    <div className="ai-modal-title">
                        <Sparkles size={20} color="#FF5526" />
                        <h3>Improve with AI</h3>
                    </div>
                    <button className="modal-close-btn" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                <div className="ai-modal-body">
                    <p className="ai-instructions-text">What would you like to change? (e.g. "Make it more technical", "Shorten this section")</p>
                    <textarea
                        placeholder='e.g. "Make it more formal and rewrite the list items as professional bullets."'
                        className="ai-modal-textarea"
                        value={aiPrompt}
                        onChange={(e) => setAiPrompt(e.target.value)}
                        autoFocus
                    ></textarea>
                </div>

                <div className="ai-modal-footer">
                    <button className="cancel-modal-btn" onClick={onClose}>Cancel</button>
                    <button
                        className="ai-trigger-btn"
                        onClick={onRefine}
                        disabled={isRefining || !aiPrompt}
                    >
                        {isRefining ? <CustomLoader className="spin" size={18} /> : <Sparkles size={18} />}
                        <span>{isRefining ? 'Refining...' : 'Refine Content'}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AIImprovementModal;
